import React from 'react';
import './Payment_methods.css';

import {CardElement} from '@stripe/react-stripe-js';
import { Link } from 'react-router-dom';

import MasterButton from '../general_components/MasterButton/MasterButton.js';
import stripe_CC_badge from '../../images/stripe_imgs/stripe_cards_badge.png'
import GG_loader from '../general_components/GG_loader/GG_loader';
import Overlay_popup from '../general_components/Overlay_popup/Overlay_popup';
import GGApi from '../../utils/GGApi';

import stripe_logo from '../../images/stripe_imgs/stripe_black.png';

import { formatSendFeeRate } from '../../utils/monthly_gift_pricing.js';

import config from '../../utils/config';

import { logEvent } from '../../utils/analytics';

import InstantBankPlaid, { InstantBankPlaidTab } from './instant_bank/InstantBankPlaid';
import InstantBankFc, { InstantBankFcTab } from './instant_bank/InstantBankFc';
import { preparePlaidOauthStorage } from './instant_bank/instantBankShared';

// check if the instant bank provider is financial connections
const USE_FC_INSTANT = config.instant_bank_provider === 'financial_connections';

class Payment_methods extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
            loading: false,

            method_type: '',
            verification: '',

            account_number: '',
            routing_number: '',
            new_manual_bank: {},

            overlay_open: false,

            save_method: true,

            plaid_link_token: '',
            plaid_session: ''
        };

        this.toggle                 = this.toggle.bind(this);
        this.handleChange           = this.handleChange.bind(this);

        this.renderCC               = this.renderCC.bind(this);
        this.handleCCSubmit         = this.handleCCSubmit.bind(this);

        this.renderBank             = this.renderBank.bind(this);
        this.renderManual           = this.renderManual.bind(this);
        this.handleOverlayButton    = this.handleOverlayButton.bind(this);
        this.handleBankButton       = this.handleBankButton.bind(this);
        this.handleInstantClick     = this.handleInstantClick.bind(this);
        this.setParentState         = this.setParentState.bind(this);

        this.renderDisclaimer       = this.renderDisclaimer.bind(this);
        this.renderStripe           = this.renderStripe.bind(this);


    }
    
    componentDidMount(){
        if (this.props.open_payments) {
        logEvent('add pm: start add pm', { source: 'payment_methods' });
        }

        // check if there is a plaid link in the props. If so, it is a continuation from oauth flow
        if(this.props.plaid_link_token && this.props.plaid_session) {
            this.setState({
                plaid_link_token: this.props.plaid_link_token, 
                plaid_session: this.props.plaid_session,
                verification: 'Instant',
            })
        }

        // check if there is a financial connections client secret in the props. If so, it is a continuation from financial connections flow
        if(this.props.fc_client_secret && this.props.fc_return_session) {
            this.setState({ verification: 'Instant' });
        }
    }

    setParentState(partial) {
        this.setState(partial);
    }

    toggle(){
        this.setState({save_method: !this.state.save_method})
    }

    handleChange(event) {
        const { name, value} = event.target;
        this.setState({[name]: value});
    }

    // credit card methods

    renderCC(){
        if (this.state.method_type === 'CC') {
            const {stripe} = this.props;

            
            return (
                <form onSubmit={this.handleCCSubmit}>

                    <div>
                        <CardElement options={{
                            style: {
                                complete: {
                                    color: '#16dfad',
                                },
                            },
                        }}/>
                    </div>

                    <button type="submit" 
                            disabled={!stripe} 
                            style={{'width': '100%'}} 
                            className='stripe_button'>
                        Add Card
                    </button>

                </form>
            )
        } else {
            return null;
        }
    }

    handleCCSubmit(event){
        // Block native form submission.
        event.preventDefault();
    
        const {stripe, elements} = this.props;
    
        if (!stripe || !elements) {
          // Stripe.js has not loaded yet. Make sure to disable form submission until Stripe.js has loaded.
          return;
        }
        // Get a reference to a mounted CardElement. Elements knows how to find your CardElement because there can only ever be one of
        // each type of element.
        const cardElement = elements.getElement(CardElement);
        

        // create a payment method through stripe.js, and get back a pm item with payment info.
        const user = JSON.parse(localStorage.getItem('user'));
        // if registered user - add billing name. 
        // otherwise, it's a guest checkout
        if(user){
            stripe.createPaymentMethod({
                type: 'card',
                card: cardElement,
                billing_details: {
                    name: (user.first_name + ' ' + user.last_name),
                  }
    
            }).then(response => {
                if (response.error) {
                    console.log('error', response.error);
                    if(response.error.message) {alert(response.error.message)}
                  } else {
                    this.props.updateCard(response.paymentMethod, this.state.save_method, );
                  }
            }); 

        } else if(!user){
            stripe.createPaymentMethod({
                type: 'card',
                card: cardElement,
    
            }).then(response => {
                if (response.error) {
                    console.log('error', response.error);
                  } else {
                    this.props.updateCard(response.paymentMethod, this.state.save_method, );
                  }
            }); 
        }     
      };


    // bank methods

    renderBank(){
        if (this.state.method_type === 'ACH') {
            return (
                <div>

                    <h2>Bank verification</h2>

                    <div className='click_button_wrapper'>
                        
                        <div className='click_button_rec_container'>
                            <p className='tiny_text green_text'>Recommended</p>
                            
                        </div>
                        
                        <div className='click_button_container'>
                        
                            {USE_FC_INSTANT ? (
                                <InstantBankFcTab
                                    verification={this.state.verification}
                                    onSelect={() => this.setState({ verification: 'Instant' })}
                                />
                            ) : (
                                <InstantBankPlaidTab
                                    verification={this.state.verification}
                                    onSelect={this.handleInstantClick}
                                />
                            )}
                     
                      {/* Manual Verification */}

                        {
                            <div onClick={() => this.setState({verification: 'Manual'})}
                                className={this.state.verification === 'Manual' ? 'click_button_selected click_button' : 'click_button'}>
                                <p className='bold'>Manual Verification</p>
                                <p className='small_text'>Use your bank’s routing and account number. Verification can take up to 3 business days.</p>
                            </div>
                        }
                        </div>
                    </div>

                    {this.renderManual()}
                    {USE_FC_INSTANT ? (
                        <InstantBankFc
                            stripe={this.props.stripe}
                            verification={this.state.verification}
                            setParentState={this.setParentState}
                            save_gift_for_oauth={this.props.save_gift_for_oauth}
                            cleanupFcOauth={this.props.cleanupFcOauth}
                            bankNext={this.props.bankNext}
                            fc_client_secret={this.props.fc_client_secret}
                            fc_return_session={this.props.fc_return_session}
                            oauthResumeOnly={false}
                        />
                    ) : (
                        <InstantBankPlaid
                            verification={this.state.verification}
                            plaid_link_token={this.state.plaid_link_token}
                            plaid_session={this.state.plaid_session}
                            setParentState={this.setParentState}
                            save_gift_for_oauth={this.props.save_gift_for_oauth}
                            cleanupOauth={this.props.cleanupOauth}
                            bankNext={this.props.bankNext}
                            oauthResumeOnly={false}
                        />
                    )}
                </div>
            )
        } else {
            return null;
        }
    }

    renderManual(){
        if(this.state.verification !== 'Manual') {
            return null;
        } else {
            return (
                <div>
                    <form>
                        <p className='form_label'>Routing Number</p> 
                        <input 
                            type={this.state.show_details? 'text' : 'password'} 
                            name='routing_number' 
                            id='routing_number' 
                            onChange={this.handleChange}
                            placeholder='123-456-789' 
                            value={this.state.routing_number}
                            autoComplete='off'
                            maxLength='9'
                            />

                        <p className='form_label'>Account Number</p> 
                        <input 
                            type={this.state.show_details? 'text' : 'password'}
                            name='account_number' 
                            id='account_number' 
                            onChange={this.handleChange}
                            placeholder='123-456-789' 
                            value={this.state.account_number}
                            autoComplete='off'
                            maxLength='30'
                            />
                    </form>
                    <div className='disclaimer_checkbox_container'>
                        {this.state.show_details ?
                            <i onClick={() => this.setState({show_details: !this.state.show_details})} className='material-icons-outlined disclaimer_checkbox'>check_box</i> :
                            <i onClick={() => this.setState({show_details: !this.state.show_details})} className='material-icons-outlined disclaimer_checkbox'>check_box_outline_blank</i>}
                        <p className='disclaimer_checkbox_text tiny_text'>Show routing and account numbers</p>
                    </div>

                    {/* ACH mandate authorization — submitting the form is acceptance (mandate_data captured server-side) */}
                    <p className='tiny_text' style={{color: '#6b7280', marginTop: '8px'}}>
                        By clicking "Add bank", you authorize Greatest Gift to debit the bank account
                        specified above for any amount owed for charges arising from your use of Greatest
                        Gift's services, pursuant to Greatest Gift's website and terms, until this
                        authorization is revoked. You may amend or cancel this authorization at any time
                        by providing notice to Greatest Gift with 30 (thirty) days notice. Payments are
                        processed by our partner, Stripe.
                    </p>

                    <MasterButton 
                            buttonText={'Add bank'} 
                            handleButtonClick={this.handleBankButton}
                            notSticky={true}
                        /> 
                    
                    <Overlay_popup 
                        open={this.state.overlay_open}
                        closer={false}
                        overlay_title='Next Steps'
                        body_1='To verify your account, our payments partner Stripe sends a small deposit to your account in the next 1-2 business days. Your statement will show a 6-character verification code (for example, SM followed by 4 characters).'
                        body_2='To finish verification, go to Settings → Payment Methods and enter that code.'
                        button_1={  {   text: 'Next',
                                        handler: this.handleOverlayButton                        
                                    }}
                    />

                </div>
                
            )
        } 
    }

    handleOverlayButton(){
        // reset the payments page
        this.setState({
            method_type: '',
            verification: '',

            account_number: '',
            routing_number: '',
            new_manual_bank: {},

            overlay_open: false,

            save_method: true
        })
        // move on to next step in the gift flow
        this.props.bankNext(this.state.new_manual_bank);
    }

    handleBankButton(){
        this.setState({loading: true});
        
        // verify the user token
        let user = JSON.parse(localStorage.getItem('user'));
        let validToken = true; 
        if (!user ) {
            this.setState({loading: false});
            return;
        } else if (user) {
            GGApi.checkToken().then(response => {
                validToken = response;
                if (validToken === false) {
                    this.setState({loading: false});
                    return;
                }
            })
        }

        if(this.state.verification === 'Manual'){
            // Validate inputs before hitting any API
            if(!this.state.routing_number || this.state.routing_number.length !== 9) {
                alert('Please submit a valid 9-digit routing number.')
                this.setState({loading: false});
                return;
            } 
            if(!this.state.account_number) {
                alert('Please submit your account number.')
                this.setState({loading: false});
                return;
            };

            const { stripe } = this.props;
            if (!stripe) {
                alert('Payment system is not ready. Please refresh the page and try again.');
                this.setState({loading: false});
                return;
            }

            
            // set up the routing and account numbers
            const { routing_number, account_number } = this.state;

            // FE-to-Stripe 3-step flow 
            //   Step 1: BE creates an unconfirmed SetupIntent, returns client_secret + holder info.
            //   Step 2: FE sends the bank details directly to Stripe via stripe.confirmUsBankAccountSetup().
            //   Step 3: BE receives just the setup_intent_id and persists the pm_ from Stripe.

            // step 1: create an unconfirmed SetupIntent
            GGApi.bank_manual_start()
                .then(startResponse => {
                    if (!startResponse.success) {
                        throw new Error(startResponse.message || 'Could not start bank setup.');
                    }

                    const { client_secret, holder_name, email } = startResponse;

                    // Step 2: send routing/account directly to Stripe 
                    return stripe.confirmUsBankAccountSetup(client_secret, {
                        payment_method: {
                            billing_details: {
                                name: holder_name,
                                email: email,
                            },
                            us_bank_account: {
                                account_number: account_number,
                                routing_number: routing_number,
                                account_holder_type: 'individual',
                                account_type: 'checking',
                            },
                        },
                        // Stripe captures acceptance (IP + user-agent) at confirm time
                        mandate_data: {
                            customer_acceptance: {
                                type: 'online',
                                online: { infer_from_client: true },
                            },
                        },
                    });
                })
                .then(({ setupIntent, error }) => {
                    if (error) {
                        this.setState({ loading: false, account_number: '', routing_number: '' });
                        const msg = error.code === 'payment_method_bank_account_already_exists'
                            ? 'A bank account with this information already exists for your use. Please add a different bank account.'
                            : (error.message || 'We could not add this bank account. Please double-check the routing and account numbers.');
                        alert(msg);
                        return;
                    }

                    // Step 3: tell our BE to persist the pm_ Stripe attached to the SetupIntent
                    return GGApi.bank_manual_complete(setupIntent.id)
                        .then(completeResponse => {
                            if (completeResponse.success) {
                                this.setState({
                                    overlay_open: true,
                                    loading: false,
                                    account_number: '',
                                    routing_number: '',
                                    new_manual_bank: completeResponse.new_pm,
                                });
                            } else {
                                this.setState({ loading: false, account_number: '', routing_number: '' });
                                alert(completeResponse.message || 'The server encountered an error. Please try again.');
                            }
                        });
                })
                .catch(err => {
                    this.setState({ loading: false, account_number: '', routing_number: '' });
                    alert(err.message || 'The server encountered an error. Please try again, or try a different payment method.');
                });
        } 
    }

    // Instant verification — Plaid link token fetch (FC uses InstantBankFc directly)
    handleInstantClick(){
        this.setState({verification: 'Instant'});
        if(this.state.plaid_link_token){
            return;
        }
        this.setState({loading: true})
        
        GGApi.get_plaid_link('checking_accounts').then(response => {
            if(response.success){
                preparePlaidOauthStorage(this.props.save_gift_for_oauth);
                localStorage.setItem("plaid_link_token", JSON.stringify(response.link_token));
                this.setState({plaid_link_token: response.link_token, loading: false});
            } else {
                this.setState({loading: false});
            };
        });
    }

    renderInstantOAuthResume(){
        if (USE_FC_INSTANT && this.props.fc_client_secret && this.props.fc_return_session) {
            return (
                <div>
                    <GG_loader />
                    <InstantBankFc
                        stripe={this.props.stripe}
                        verification="Instant"
                        setParentState={this.setParentState}
                        save_gift_for_oauth={this.props.save_gift_for_oauth}
                        cleanupFcOauth={this.props.cleanupFcOauth}
                        bankNext={this.props.bankNext}
                        fc_client_secret={this.props.fc_client_secret}
                        fc_return_session={this.props.fc_return_session}
                        oauthResumeOnly={true}
                    />
                </div>
            );
        }
        if (!USE_FC_INSTANT && this.state.plaid_link_token && this.state.plaid_session) {
            return (
                <div>
                    <GG_loader />
                    <InstantBankPlaid
                        verification="Instant"
                        plaid_link_token={this.state.plaid_link_token}
                        plaid_session={this.state.plaid_session}
                        setParentState={this.setParentState}
                        save_gift_for_oauth={this.props.save_gift_for_oauth}
                        cleanupOauth={this.props.cleanupOauth}
                        bankNext={this.props.bankNext}
                        oauthResumeOnly={true}
                    />
                </div>
            );
        }
        return null;
    }

    // general methods

    renderDisclaimer(){
        if (this.state.method_type === 'CC' ){
            return (
            <div className='disclaimer_checkbox_container'>
                {this.state.save_method ?
                <i onClick={this.toggle} className='material-icons-outlined disclaimer_checkbox'>check_box</i> :
                <i onClick={this.toggle} className='material-icons-outlined disclaimer_checkbox'>check_box_outline_blank</i>}
                <p className='disclaimer_checkbox_text tiny_text'>Save payment method for future use</p>
            </div> 
            )
        } else if (this.state.method_type === 'ACH' && this.state.verification){
            return (
                <div className='disclaimer_checkbox_container'>
                <i className='material-icons-outlined disclaimer_checkbox'>info</i>
                <p className='disclaimer_checkbox_text tiny_text'>Bank accounts are automatically saved for future use</p>
            </div> 
            )
        } else {
            return null;
        }
    }
    
    renderStripe(){
        //if(this.state.method_type === 'CC') {
            return (
                <div>
                    <div className='stripe_cc_badge_wrapper'>
                        <img className='stripe_badge' src={stripe_CC_badge} />
                    </div>
                    <p className='tiny_text'>Your bank account or credit card information will be used by <a target="_blank" href='https://stripe.com/customers' className='green_text '>Stripe’s secure platform</a> (a payment platform used by Uber, Spotify, Postmates, and many more) to process payments, and Greatest Gift will never keep any of your bank account or credit card information on our servers. 
                    <br></br>Learn more about our security practices <a target="_blank" href='https://www.greatestgiftapp.com/#security' className='green_text '>here.</a></p>
                </div>
            )
        //} else {
        //    return null;
        //}
    }

    getSendFeeLabels() {
        const isMonthly = !!this.props.isMonthlyGift;
        return {
            ach: formatSendFeeRate('ACH', isMonthly),
            cc: formatSendFeeRate('CC', isMonthly),
        };
    }

    // render

    render () {
        if (!this.props.open_payments) {
            return null;
        }
        if(this.state.loading) {
            return (
                <GG_loader />
            )
        }

        const oauthResume = this.renderInstantOAuthResume();
        if (oauthResume) {
            return oauthResume;
        }
        
        const { ach: ach_send_fee, cc: cc_send_fee } = this.getSendFeeLabels();

        return (
           <div>
                <h2>Choose payment method type</h2>

                <div className='click_button_wrapper'>
                 {this.props.guest ? 
                    <div className='click_button_rec_container'>
                        <p className='tiny_text green_text'>
                        <Link to={this.props.return_to ? '/new_account?return_to=' + encodeURIComponent(this.props.return_to) : '/new_account?source=give-a-gift' + '&' + window.location.search.slice(1)} className='green_text' onClick={() => {this.props.remember_gift(); logEvent('signup: click sign up', { page: 'pm', source: 'payment_methods' });}}>Register to unlock</Link>
                        </p>
                    </div>
                 :
                    <div className='click_button_rec_container'>
                        <p className='tiny_text green_text'>Recommended</p>
                    </div>
                }

                    {/* click_button_container_single */}
                    <div className={this.props.guest ? 'click_button_container ' : 'click_button_container'}>
                    
                    {this.props.guest ?
                        <div 
                            className={'click_button unavailable_click_button'}>
                            <i className={'material-icons-outlined'}>account_balance</i>
                            <p className='bold click_button_header'>Bank</p>
                            <p className='small_text'>Send a gift with a low {ach_send_fee} fee by using a direct bank ACH payment</p>
                        </div>
                    :
                        <div onClick={() => {this.setState({method_type: 'ACH'}); logEvent('add pm: select method type', { source: 'payment_methods', method_type: 'bank' });}}
                            className={this.state.method_type === 'ACH' ? 'click_button_selected click_button' : 'click_button'}>
                            <i className={this.state.method_type === 'ACH' ? 'material-icons-outlined green_icon' : 'material-icons-outlined'}>account_balance</i>
                            <p className='bold click_button_header'>Bank</p>
                            <p className='small_text'>Send a gift with a low {ach_send_fee} fee by using a direct bank ACH payment</p>
                        </div>
                    }
                        

                        <div onClick={() => {this.setState({method_type: 'CC'}); logEvent('add pm: select method type', { source: 'payment_methods', method_type: 'credit card' });}}
                            className={this.state.method_type === 'CC' ? 'click_button_selected click_button' : 'click_button'}>
                            <i className={this.state.method_type === 'CC' ? 'material-icons-outlined green_icon' : 'material-icons-outlined'}>credit_card</i>
                            <p className='bold click_button_header'>Credit Card</p>
                            <p className='small_text'>We charge a standard {cc_send_fee} processing fee for credit cards. However, banks have minimal fees!</p>
                        </div>
                
                    </div>
               
                </div>
                
                {this.renderCC()}
                {this.props.guest ? null : this.renderBank()}
            

                {this.props.guest ? 
                    <div>
                        <p>Payment with banks are only available to registered Greatest Gift users. <br></br>
                        <Link to={this.props.return_to ? '/new_account?return_to=' + encodeURIComponent(this.props.return_to) : '/new_account?source=give-a-gift' + '&' + window.location.search.slice(1)} className='green_text bold' onClick={() => {this.props.remember_gift(); logEvent('signup: click sign up', { page: 'pm', source: 'payment_methods' });}}>Create an account </Link>
                        to access minimal {ach_send_fee} fees.</p>
                        <p>Or, if you already have an account, you can 
                        <Link to={this.props.return_to ? '/login?return_to=' + encodeURIComponent(this.props.return_to) : '/?source=give-a-gift' + '&' + window.location.search.slice(1)} 
                            className='green_text bold' 
                            onClick={() => {
                                this.props.remember_gift();
                                this.props.remember_gift_link();
                                logEvent('signup: click log in', { page: 'pm', source: 'payment_methods' });
                            }}
                            > Log In here.</Link></p>
                    </div>
                 : this.renderDisclaimer()}
                
                {this.renderStripe()}

                {/*<div>
                    <div className='powered_by_stripe_container'>
                        <i className='material-icons-outlined'>lock</i>
                        <p className='disclaimer_checkbox_text tiny_text'>Guaranteed <span className='bold'>{"safe & secure"}</span> transactions</p>
                        <div className='stripe_and_plaid_container'>
                            <a target='_blank' href='https://www.stripe.com'><img src={stripe_logo}/></a>
                            <a target='_blank' href='https://plaid.com/how-it-works-for-consumers/'><img src={plaid_logo}/></a>
                        </div>
                    </div>
                    <p className='tiny_text'>Your bank account or credit card information will be used by <a target="_blank" href='https://stripe.com/customers' className='green_text '>Stripe’s secure platform</a> (a payment platform used by Uber, Spotify, Postmates, and many more) to process payments, and Greatest Gift will never keep any of your bank account or credit card information on our servers. 
                    <br></br>Learn more about our security practices <a target="_blank" href='/#faq' className='green_text '>here.</a></p>
                </div>*/}
                
           </div>
        );
    }
}

export default Payment_methods;